const CONTAINER_ID = 'paymobContainer';

const SCRIPT_ID = 'paymobScript';

const SCRIPT_URL = `${process.env.PROVIDER_PAYMOB_URL}/main.js`;

export { CONTAINER_ID, SCRIPT_ID, SCRIPT_URL };
